import { render, staticRenderFns } from "./ProfileInnerHeaderUserName.vue?vue&type=template&id=6290595d&scoped=true&"
import script from "./ProfileInnerHeaderUserName.vue?vue&type=script&lang=ts&"
export * from "./ProfileInnerHeaderUserName.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInnerHeaderUserName.vue?vue&type=style&index=0&id=6290595d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290595d",
  null
  
)

export default component.exports